//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import ItemsSearchField from '../../components/Field/ItemsSearchField.vue'
import { createFieldConfig, Store } from '../../components/QSelectUtils.js'

export default {
  name: 'RequestForkliftTruckField',
  components: {
    ItemsSearchField
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      forkliftTruckFieldConfig: createFieldConfig(new Store({
        itemsFn: this.getForkliftTrucks,
        cached: false,
        searchFiltrationBySource: false,
        searchable: true,
        fullReadable: true
      }))
    }
  },
  computed: {
    forkliftTruckValue: {
      get: function () {
        return this.request.forkliftTruckRequired && this.request.requestForkliftTruck ? this.request.requestForkliftTruck : null
      },
      set: function (value) {
        const forkliftTruck = value
        this.request.requestForkliftTruck = forkliftTruck
        if (forkliftTruck) {
          if (!this.request.forkliftTruckRequired) {
            this.request.forkliftTruckRequired = true
          }
        }
      }
    }
  },
  methods: {
    getForkliftTrucks: function () {
      return axiosGet({
        url: '/service/delta/vehicle/forkliftTrucks?onlyForkliftTrucks=true&onlyInUse=true',
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения доступных для выбора автовышек'
      })
    }
  }
}

